exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".file-list[data-v-a17e21f6]{display:flex;flex-direction:column;gap:.3rem}.file-item[data-v-a17e21f6]{display:flex;align-items:center;padding:1rem;border:1px solid #ddd;border-radius:4px;background-color:#f9f9f9;transition:background-color .3s,box-shadow .3s;height:2.4rem}.file-item[data-v-a17e21f6]:hover{background-color:#e0e0e0;box-shadow:0 4px 8px rgba(0,0,0,.1)}.file-icon[data-v-a17e21f6]{margin-right:1rem}.file-details[data-v-a17e21f6]{flex-grow:1}.file-details .button[data-v-a17e21f6]{margin-top:.5rem}.custom-background[data-v-a17e21f6]{background-color:#0c0c0cc0}.is-alert[data-v-a17e21f6]{color:#f54444}.modal-card-body[data-v-a17e21f6]{display:flex;flex-direction:column;align-items:center}.fa-exclamation[data-v-a17e21f6]{font-size:3rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a17e21f6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/sasisopa/FilesSASISOPA.vue
// module id = 4072
// module chunks = 0